import moment from 'moment'
import React from 'react'
import css from './incentiveSales.css'
import type { DailySalesIncentiveReport } from './types'
type Props = {
  data: DailySalesIncentiveReport
  hasExpressCheckout: boolean
}

const DayRow = ({ data, hasExpressCheckout }: Props) => {
  const date = moment(data.date).format('D.M - dd')
  const euroTarget = Math.round(data.euroTarget)
  const euroActual = Math.round(data.euroActual)
  const kassuEuroActual = Math.round(data.kassuEuroActual)
  const mojovaEuroActual = Math.round(data.mojovaEuroActual)
  const expressCheckoutEuroActual = Math.round(data.expressCheckoutEuroActual)
  return (
    <tr className={css.dayRow}>
      <td>{date}</td>
      <td>{Math.round(data.chainTarget)}</td>
      <td>{euroTarget}</td>
      <td>{euroActual}</td>
      <td>{kassuEuroActual}</td>
      <td>{mojovaEuroActual}</td>
      {hasExpressCheckout && <td>{expressCheckoutEuroActual}</td>}
    </tr>
  )
}

export default DayRow
